import styles from './AccountCard.module.css';
import { formatCurrency } from '../utils/calculations';

const AccountCard = ({ account, selected, onSelect }) => {
  return (
    <div
      className={`${styles.card} ${selected ? styles.selected : ''}`}
      onClick={() => onSelect(account.id)}
      role="radio"
      aria-checked={selected}
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onSelect(account.id)}
    >
      <div className={`${styles.radio} ${selected ? styles.radioSelected : ''}`}>
        {selected && <div className={styles.radioDot} />}
      </div>
      <div className={styles.details}>
        <span className={styles.name}>{account.name}</span>
        <span className={styles.number}>••••{account.number}</span>
      </div>
      <span className={styles.balance}>{formatCurrency(account.balance)}</span>
    </div>
  );
};

export default AccountCard;
